module.exports = __webpack_public_path__ + "img/dos-x.cf895f5c.jpg";